import { TextSearchVariantIcon } from './TextSearchVariantIcon';

/**
 * author: Michael Irigoyen
 * id B1B403FA-FBA6-4219-8561-23DE3833029F
 * name text-search-variant
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-search-variant.svg
 * tags
 */
export const NotesSearchVariantIcon = TextSearchVariantIcon;
export default NotesSearchVariantIcon